module.exports = __webpack_public_path__ + "img/img(4).9f097395.png";